/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Dialog } from 'src/components';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import { translate } from 'src/i18n/tHelper';
import MesajEkle from 'src/parts/Mesaj/Detay/MesajEkle';
import { useAppDispatch, useAppSelector } from 'src/store';
import { MesajSlice } from 'src/store/Slices/Mesaj/MesajSlice';

interface INotificationDetailsProps { };

const translatePath = "parts|mesaj";
/**
 * Bildirime tıklandığında içeriğin okunduğu ve düzenlendiği bölüm.
 * readOnly statesine göre MesajEkle şekil alır ve düzenlenebilir-görüntüleyebilir oluyor mesajı
 * @param props 
 * @returns 
*/
const NotificationDetails = (props: INotificationDetailsProps): JSX.Element => {
    const userInfo = useAppSelector(s => s.userLogin.userInfo);
    const state = useAppSelector(s => s.mesaj);
    const dispatch = useAppDispatch();
    const readOnly = (state.modulActiveRow?.ekleyenKullanici !== userInfo?.id); //MesajEkle componentinde yeni mesaj eklenebilir veya düzenlenebilir ayarı için kullanılır.
    /**
     * Dialog penceresinin kapanması için kullanılan fonksiyon
     * @param event 
    */
    const closeHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(MesajSlice.actions.setModulOpen(false));
    };
    return (
        <Dialog fullWidth open={state.modulOpen} maxWidth="md">
            <DialogTitle>{translate(translatePath, "Modül Mesajları")}</DialogTitle>
            <DialogContent>
                <MesajEkle modulRow={true} initialValues={state.modulActiveRow} readOnly={readOnly} closeHandler={closeHandler} />
            </DialogContent>
        </Dialog>
    );
};

export default NotificationDetails;